import { z } from 'zod';

const AuditChangeSchema = z.object({
  from: z.any().nullable(),
  op: z.union([z.literal('replace'), z.literal('remove'), z.literal('add')]),
  path: z.string(),
  value: z.any(),
  completed: z.boolean().nullish(),
  status: z.string().nullish(),
});

export const AuditItemUpdateSchema = z.object({
  dateUpdated: z.string(),
  updatedBy: z.string().nullish(),
  updatedById: z.string().nullish(),
  changesBlob: AuditChangeSchema.array().nullish(),
});

export const AuditResponseSchema = z.object({
  createdBy: z.string().nullish(),
  createdById: z.string().nullish(),
  dateCreated: z.string(),
  dateDeleted: z.string().nullish(),
  deletedBy: z.string().nullish(),
  deletedById: z.string().nullish(),
  updates: z.array(AuditItemUpdateSchema).nullish(),
});

/**
 * local type for populating audit once properly parsed and correct data extracted
 * note: (cannot use Audit type as is due to extraction logic that is required around what is the latest action i.e. !null deleted > !null[] updated > created datetime
 * plus fetching of user's name from UUID
 */
export const AuditUserSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const AuditLogItemSchema = z.object({
  action: z
    .union([z.literal('created'), z.literal('deleted'), z.literal('updated')])
    .optional(),
  timestamp: z.date(),
  subject: z.string().optional(),
  user: z.string(),
  userId: z.string(),
  link: z.string().optional(),
  changesBlob: AuditChangeSchema.array().nullish(),
});
export const AuditLogSchema = z.object({
  audits: AuditLogItemSchema.array(),
  users: AuditUserSchema.array(),
});

// TYPES
export type AuditResponseModel = z.infer<typeof AuditResponseSchema>;
export type AuditChangeModel = z.infer<typeof AuditChangeSchema>;
export type AuditLogItemModel = z.infer<typeof AuditLogItemSchema>;
export type AuditLogModel = z.infer<typeof AuditLogSchema>;
export type AuditUserModel = z.infer<typeof AuditUserSchema>;
